<span
    class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-secondary"
>
    <i [class]="iconClasses"> </i>
</span>
